export const COGNITO_JWT = 'cognito_jwt';
